export const EMPTY_LINK = 'https://'
